import React from 'react';
import text from '../../text';
import Img from '../../components/img/Img';
import Header from './Header';
var SideContent = function() {
    return /*#__PURE__*/ React.createElement("section", {
        className: "SideContent"
    }, /*#__PURE__*/ React.createElement(Header, null), /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement("p", null, text('signUpOrLoginToGetAccess'))), /*#__PURE__*/ React.createElement(Img, {
        className: "laptop-image",
        img: "laptop-larki-app"
    }), /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement("p", null, text('howDoYouMeasureUp'))));
};
export default SideContent;
